import * as types from './action-types';

export const toggleMobileNav = () => ({
    type: types.TOGGLE_MOBILE_NAV
});

export const closeNav = () => ({
    type: types.CLOSE_NAV
});

export const toggleExpandNav = () => ({
    type: types.TOGGLE_EXPAND_NAV
});



// WEBPACK FOOTER //
// ./src/actions/navigation.js